import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../config/withDirection';

const AddCampaignWrapper = styled.div`
    .blackSection {
        // background: #333333;
        // color: #fff;
        position: relative;
        z-index: 12;

        .appDisplay__app-display {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
                -ms-flex-align: center;
                    align-items: center; }
    }
    .o-wrapper {
        padding-top: 16px;

        max-width: 1020px;
        padding-right: 1.5rem;
        padding-left: 1.5rem;                                  
        margin-right: auto;
        margin-left: auto; }
        @media (min-width: 768px) {
        .o-wrapper {
            padding-right: 40px;
            padding-left: 40px; } }
        @media (min-width: 1281px) {
        .o-wrapper {
            max-width: 1120px;
            padding-right: 1.5rem;
            padding-left: 1.5rem; } }

    .appDisplayImg__app-display {
        padding-right: 0.75rem; }
        .appDisplayImg__app-display > img {
        border: 1px solid #D8D8D8;
        width: 3.25rem;
        height: 3.25rem;
        max-width: none;
        border-radius: 1rem; }
        @media (min-width: 480px) {
        .appDisplayImg__app-display {
            padding-right: 1.5rem; }
            .appDisplayImg__app-display > img {
            width: 4.25rem;
            height: 4.25rem; } }
  
    .appName__app-display,
    .appLongName__app-display {
        margin-top: 0px;
        font-family: 'Montserrat';
        font-size: 22px;
        color: rgba(64, 55, 57, 1);;
        text-align: left;
        letter-spacing: 0.09em;
        font-size: 22px;
        font-weight: 300;

    }
  
    .appPublisher__app-display {
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.07em;
        margin-top: 8px;
    }
    .appPublisher__app-display > span {
        display: table-cell;
        overflow: hidden;
        text-overflow: ellipsis; }
    @media (min-width: 480px) {
        .appPublisher__app-display {
        font-size: 1.2rem; } }
  
    .appDisplayConcise__app-display .appDisplayImg__app-display {
         padding-right: 0.75rem; }
    .appDisplayConcise__app-display .appDisplayImg__app-display > img {
        width: 36px;
        height: 36px;
        border-radius: 5px; }



    

    .inputWrapper {
        padding-left: 10px;
        // padding-right: 10px;
        font-family: 'Montserrat';
        font-size: 20px;
        color: rgba(64, 55, 57, 1);
        text-align: center;
        letter-spacing: 0.03em;
        line-height: 18px;
        font-family: 'Montserrat-Light';
        font-size: 16px;

        .FormTextInput {
            height: 40px;
            max-width: 213px;
            border: 1px solid rgba(151, 151, 151, 1);
            border-radius: 20px;
            padding-left: 20px;
            display: -webkit-inline-box;
    
            div {
                margin: 8px;
                font-family: 'Montserrat';
                font-size: 14px;
                font-weight: 300;
                color: rgba(147, 147, 147, 1);
                text-align: left;
                letter-spacing: 0.07em;
            }
    
    
            input[type=number], input[type=text] {
                height: 38px;                
                min-width: 9rem;
                border: none;
                width: 3px;
                border-left: 1px solid rgba(151, 151, 151, 1);
            }
            
        }
        
        .react-tagsinput {
            width: 213px;
            border: 1px solid rgba(151,151,151,1);
            border-radius: 20px;
            display: -webkit-inline-box;

            span {
                padding-left: 10px;
                font-family: 'Montserrat-Light';
                font-size: 16px;
                margin: 2px;
            }
        }
    
        label {
            width: 213px;
            height: 17px;
            font-family: 'Montserrat';
            font-size: 14px;
            color: rgba(64, 55, 57, 1);
            text-align: left;
            letter-spacing: 0.04em;
            display: -webkit-inline-box;
        }
    
    }

    .regionInput{
          display: inline-block;
          .country-flag img{
            top: 0;
          }

          span{
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
          }
        }
    .isoInputWrapper {
        margin-bottom: 15px;
        justify-content: center;
        align-items: center;
        vertical-align: center;
        display: flex;
        border: 1px solid rgba(147, 147, 147, 1);
        border-radius: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }
        .searchIcon{
            position: absolute;
            top: 50%; right: 11px;
            width: 18px;
            height: 18px;
            transform: translateY(-50%);
        }
      
        .searchInput{
          width: 250px;
          display: inline-block;

          .Select-control {
            border: none;
            background-color: rgba(0,0,0,0.1);

            .Select-input:focus {
                background: rgba(255, 255, 255, 1);
                font-family: 'Montserrat';
                font-size: 14px;
                color: rgba(147, 147, 147, 1);
                text-align: justify;
                letter-spacing: 0.04em;
            }
          }
          .Select-placeholder {
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
            line-height: 17px;
            font-family: 'Montserrat';
          }
          .Select-value{
            font-size: 14px;
            color: rgba(147, 147, 147, 1);
            text-align: justify;
            letter-spacing: 0.04em;
            line-height: 17px;
            font-family: 'Montserrat';
          }

          input{
            border: none;
          }
          
        }
       
    }





    .exampleHolder > div {
        margin-left: auto;
        margin-right: auto; 
    }
    @media (min-width: 768px) {
        .exampleHolder {
        position: absolute;
        width: 80%;
        right: 0;
        } 
    }
    
    @media (min-width: 850px) {
        .exampleHolder {
            width: 100%; 
        } 
    }

    .budgetText{
        font-family: 'Montserrat';
        font-size: 10px;
        font-weight: 300;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.04em;
        line-height: 18px;
    }
    
    .react-tagsinput-tag{
        background-color: transparent;
        1px solid rgba(147, 147, 147, 1);
    }

    .isoWidgetsWrapper{

        margin-left: auto;
        margin-right: auto;
        height: 487px;
        width: 343px;
        background-color: rgba(255, 255, 255, 1);
    }
    .footer {
        background-color: rgba(35, 31, 32, 1);
        padding: 17px;
        .footerTitle{
            font-family: 'Montserrat';
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            letter-spacing: 0.07em;
        }
    }

    .budgetSimpleWrapper{
        .allCountryLabel{
            padding: 0 8px;
            font-family: 'Roboto';
            color: rgba(64,55,57,1);
        }
        .country-label{
            font-family: 'Roboto';
            font-size: 12px;
            color: rgba(64,55,57,1);
        }
    }
    
    // -- Simpliefed modification by Tom
    

    
    // -- Zay modification
    .header {
        margin-bottom: 36px;
        position:relative;
        background-color: rgba(35, 31, 32, 1);
        padding: 29px;
        .greenLogo{
            margin-left: auto;
            margin-right: auto;    
            height: 77px;
            width: 118px;
        }

        .greenLogo { height: auto; }
        
        *:last-child {
            // margin-top: 34px;
            font-family: 'Montserrat';
            font-size: 14px;
            font-weight: 300;
            color: rgba(219, 219, 219, 1);
            text-align: center;
            letter-spacing: 0.08em;
        }
    }
    .header:after {
        position: absolute;
        display: inline-block;
        content: '';
        right: 0; bottom: -3px; left: 0;
        height: 3px;
        background-color: rgba(12, 183, 148, 1);
    }
    
    .container {
        margin-bottom: 42px;
        background-color: rgba(255, 255, 255, 1);
    }
        .container > form > .blackSection:first-child { z-index: 13; }
        .container form > * { margin: 0 -15px; }
        .container form > .blackSection { background-color: rgba(249, 249, 249, 1); }
            .container .o-wrapper { max-width: auto; max-width: unset; max-width: none; }
            .container .o-wrapper { min-height: 160px; padding-top: 42px; padding-right: 39px; padding-left: 45px; }
                .container .o-wrapper .appDisplay__app-display h1 { text-transform: uppercase; }
                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select {
                    padding-bottom: 0;
                    border-right: 1px solid rgba(151, 151, 151, 1);

                    span.country-flag {
                        display: inline-block;
                        width: auto !important;
                        height: auto !important;
                        line-height: 38px;

                        img { width: auto; height: 1.5em; }
                        img + span { display: inline-block; line-height: 1.5em; }
                    }
                }
                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput {
                    width: 55%;
                    .Select-control {
                        position: relative;
                        background-color: transparent;
                        line-height: 38px;

                        > *, .Select-placeholder { display: inline-block; line-height: 38px; }
                        .Select-placeholder { position: absolute; top: 0; right: 0; left: 0; }
                        .Select-input { display: block !important; height: 38px; }
                        .Select-loading-zone { position: absolute; right: 20px; }
                        .Select-arrow-zone { display: none; }
                        input:focus, input:active { outline-width: 0; }

                        > * > div { line-height: 38px; }
                        input { width: auto !important; padding: 0; line-height: 38px; }
                    }
                }
                .container .o-wrapper .isoSignInForm .isoInputWrapper {
                    .flag-select + .Select.is-focused:not(.is-open) > .Select-control {
                        box-shadow: none;
                    }
                }

                .container .o-wrapper .isoSignInForm {
                    max-width: 300px;
                    float: right;

                    .isoInputWrapper {
                        height: 40px;

                        .searchInput {
                            height: 40px;
                            line-height: 40px;

                            .Select-control,
                            .Select-multi-value-wrapper,
                            .Select-placeholder,
                            .Select-input,
                            input {
                                display: inline-block;
                                height: 40px;
                                line-height: 40px;
                            }

                            .Select-value { padding-right: 74px; }
                            .Select-clear-zone { position: absolute; top: 50%; right: 4px; transform: translateY(-50%); }
                        }
                    }
                    
                    .Select-menu-outer {
                      top: auto; right: -19px; bottom: 0; left: -1px;
                      width: auto;
                      transform: translateY(100%);
                      background-color: rgba(255, 255, 255, .5);
      
                      .Select-option {
                        height: 64px;
                        padding: 12px; 2px;
                        
                        .app-div-anchor {
                            display: flex;
                            justify-content: flex-start !important;
                            align-items: center;

                            div {
                                img {
                                    display: inline-block;
                                    margin: 0; padding: 0;
                                    width: 40px; height: 40px;
                                    border-radius: 3px;
                                }
                                :first-child { flex-basis: 40px; width: 40px; min-width: 40px; }
                                :last-child {
                                    flex-grow: 1;
                                    padding-right: 2px;
                                    padding-left: 11px;
                                    text-align: left;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                            }
                        }
                      }
                    }
                }
        .container .blackSection:first-child ~ * { padding-right: 50px; padding-left: 64px; }
        .container .blackSection:first-child + div {
            line-height: 60px;
            font-family: 'Montserrat';
            font-size: 14px;
            color: rgba(64, 55, 57, 1);
            text-transform: uppercase;
        }

        .container .blackSection ~ .blackSection {
            padding-top: 24px;

            > div:first-child {
                margin-bottom: 20px;

                + div > div { margin-bottom: 0 !important; }
            }
            .isoExampleWrapper {
                margin-top: 0;
                input { background-color: transparent; }
                input:focus, input:active { outline-width: 0; }
            }

            .inputWrapper {
                padding: 0;
                text-align: left;
                
                img {
                    width: 16px;
                }

                // label {
                //     margin-bottom: 8px;
                //     display: block;
                //     width: auto;

                //     span {
                //         display: inline-block;
                //         margin-left: 4px;
                //         border: 1px solid rgba(147, 147, 147, 1);
                //         border-radius: 100%;
                //         width: 14px; height: 14px;
                //         line-height: 14px;
                //         font-family: 'Montserrat';
                //         text-align: center;
                //         font-size: .7em;
                //         color: rgba(147, 147, 147, 1);
                //     }
                // }

                .FormTextInput {
                    margin-left: -7px;
                    padding-right: 4px;

                    > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }
                }
            }
            
            .BudgetTC p { margin-top: 29px; margin-bottom: 39px; font-size: 11px; color: rgba(64, 55, 57, 1); }

            .advanced-settings {
                margin-right: -50px;
                margin-left: -64px;

                .ant-collapse-header {
                    height: 60px;
                    padding: 0 50px 0 64px;
                    background-color: rgba(252, 252, 252, 1);
                    line-height: 60px;
                    font-family: 'Montserrat';
                    color: rgba(64, 55, 57, 1);
                    letter-spacing: 0.08em;

                    .arrow { line-height: 60px; float: right; }
                    .arrow + div {
                        font-size: 14px;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.08em;

                        @media screen and (max-width: 767px) { letter-spacing: 0.04em; }

                        span { color: rgba(147, 147, 147, 1); }
                    }
                }

                .ant-collapse-item { background-color: transparent; }
                .ant-collapse-content {
                    background-color: rgba(219, 219, 219, 0.35);
                    padding: 0 50px 0 64px;

                    label:first-child {
                        margin-top: 23px;
                        font-family: 'Montserrat';
                        font-size: 14px;
                        color: color: rgba(64, 55, 57, 1);
                        letter-spacing: 0.04em;
                    }

                    label:first-child + p { font-family: 'Montserrat'; font-size: 11px; margin-bottom: 17px; }

                    label ~ div {
                        margin: 0; margin-bottom: 27.5px; margin-left: -10px;

                        .regionInput {
                            position: relative;
                            margin: 0;
                            padding: 0;
                            border-radius: 20px;
                            width: 101px;
                            background-color: #fff;
                            line-height: 41px;
                            text-align: center;

                            img { width: 24px; height: 18px; }
                            .country-label {
                                width: 17px;
                                line-height: 16px;
                                font-family: 'Roboto';
                                font-size: 12px;
                                color: rgba(64, 55, 57, 1);
                                letter-spacing: 0.04em;
                            }
                        }
                        &[desc='0%'] > .regionInput:after {
                            position: absolute;
                            top: 0; right: 0; bottom: 0; left: 0;
                            display: inline-block;
                            content: '';
                            border-radius: 20px;
                            background-color: rgba(216, 216, 216, 0.6);
                        }

                        .rc-slider {
                            width: 60%;
                            margin-left: 11px;
                            margin-right: 37px;

                            .rc-slider-rail { height: 2px; }
                            .rc-slider-track { border-width: 2px; border-color: rgba(60, 211, 207, 1); height: 2px; }
                                .rc-slider-track:after {
                                    position: absolute;
                                    top: 50%; right: 0;
                                    display: inline-block;
                                    content: attr(desc);
                                    border: 1px solid rgba(0, 0, 0, .1);
                                    border-radius: 31px;
                                    background-color: rgba(255, 255, 255, 1);
                                    width: 31px; height: 31px;
                                    line-height: 31px;
                                    text-align: center;
                                    font-family: 'Montserrat';
                                    font-size: 10px;
                                    font-weight: 300;
                                    color: rgba(64, 55, 57, 1);
                                    letter-spacing: 0.04em;
                                    transform: translateX(50%) translateY(-50%);
                                    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.17);
                                }
                                .rc-slider-track[desc='0%']:after { right: -10px; content: ''; }
                            [role="slider"] { opacity: 0; }
                        }

                        .rc-slider ~ .inputWrapper {
                            input { background-color: transparent; }
                            input:focus, input:active { outline-width: 0; }
                        }    

                        [desc='0%'] ~ .inputWrapper {
                            .FormTextInput {
                                border-color: rgba(216, 216, 216, 0.6);
                                
                                * { color: rgba(216, 216, 216, 0.6); }
                                input { border-color: rgba(216, 216, 216, 0.6); }
                            }
                        }
                    }

                    > .ant-collapse-content-box { margin-bottom: 0; }
                    label ~ div:last-child { margin-bottom: 0; }
                }

                .tagInputWrapper{
                    margin: 0 -50px 0 -64px;
                    width: auto !important;
                    background-color: rgba(219, 219, 219, 0.35);
                    padding: 0 50px 0 64px;
                }
                .inputWrapper {
                    position: relative;
                    margin: 0; padding: 0;
                    
                    label ~ .react-tagsinput {
                        margin: 0; margin-left: -7px;
                        padding: 0;
                        background-color: transparent;
                        line-height: 41px;

                        span { padding: 0; margin-left: 21px; }

                        + img {
                            position: absolute;
                            bottom: 15px;
                            width: 20px;
                            height: 19px;
                            line-height: 19px;
                            transform: translateX(-44px);
                        }
                    }
                    input { 
                        font-family: 'Montserrat-Light';
                        font-size: 16px;
                        margin: 0; 
                        margin-left: 21px;
                        border-width: 0; 
                        background-color: 
                        transparent; padding: 0; 
                        line-height: 41px; 
                    }
                    input:focus, input:active { outline-width: 0; }
                    label ~ .FormTextInput input { border-left-width: 1px; padding-left: 14px; }
                }
            }

            > :last-child, > :nth-last-child(2) {
                margin: 0 -50px 0 -64px;
                width: auto !important;
                background-color: rgba(219, 219, 219, 0.35);
                padding: 0 50px 0 64px;

               
            }

            > :nth-last-child(2) {
                p:first-child {
                    margin-top: 25px;
                    margin-bottom: 16px;
                    font-family: 'Montserrat';
                    font-size: 14px;
                    color: rgba(64, 55, 57, 1);
                    letter-spacing: 0.04em;
                }
            }

            > :last-child {
                background-color: rgba(255, 255, 255, 1);

                .campaign-holder {
                    margin-top: 19px;
                    margin-bottom: 42px;
                    border: 1px solid rgba(170, 170, 170, 0.5);
                    padding: 20px 10%;

                    .isoExampleWrapper {
                        margin: 0;
                        .exampleHolder {
                            position: relative;

                            // .searchTerm__ad-example { top: 9.5%; left: 19.2%; }
                            // .container__ad-example { top: 15.4%; width: 87.5%; }
                        }
                    }
                    .btn-create-campaign {
                        margin-top: 86px;
                        margin-left: 65px;
                        max-width: 270px;
                        width: 100%;
                        padding: 0;
                        background-color: rgba(60, 211, 207, 1);

                        line-height: 38px;
                        font-family: 'Montserrat';
                        font-size: 15px;
                        color: rgba(255, 255, 255, 1);
                        text-align: center;
                        letter-spacing: 0.01em;
                        border-radius: 20px;

                        img {
                            height: 18px;
                            transform: rotate(90deg) translateY(-14px);
                            filter: brightness(0) invert(1);
                        }
                    }

                    .btn-create-campaign + * {
                        margin-top: 20px;
                        margin-left: 65px;
                        padding: 0;

                        input[type='checkbox'] {
                            position: absolute;
                            margin-left: -10px;
                            transform: translateX(-100%);
                        }

                        label {
                            margin: 0;
                            line-height: 18px;
                            font-family: 'Montserrat';
                            font-size: 12px;
                            font-weight: 300;
                            color: rgba(64, 55, 57, 1);
                            letter-spacing: 0.04em;

                            + small {
                                margin-top: 3px;
                                font-family: 'Roboto';
                                font-size: 10px;
                                color: rgba(221, 66, 85, 1);

                                + div {
                                    margin-top: 27px;
                                    line-height: 18px;
                                    font-family: 'Montserrat';
                                    font-size: 12px;
                                    font-weight: 300;
                                    color: rgba(64, 55, 57, 1);
                                    letter-spacing: 0.04em;

                                    a {
                                        line-height: 18px;
                                        font-family: 'Montserrat';
                                        font-size: 12px;
                                        font-weight: 300;
                                        color: rgba(60, 211, 207, 1);
                                        letter-spacing: 0.04em;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        
        @media screen and (max-width: 767px) {
            .container {
                margin-right: 16px;
                margin-left: 16px;

                .o-wrapper {
                    padding-top: 12px; padding-right: 32px; padding-left: 17px;

                    .appDisplay__app-display img { width: 85px; height: auto; }
                }

                .blackSection:first-child + div { padding-left: 21px; }
                .blackSection:first-child ~ .blackSection {
                    padding-right: 24px;
                    padding-left: 11px;

                    .inputWrapper .FormTextInput { margin-left: 0; }

                    > div:first-child { margin-bottom: 16px; }
                    > div:first-child + div {
                        > *:not(:first-child) { margin-top: 25px; }
                    }

                    .advanced-settings {
                        margin-right: -24px; margin-left: -11px;
                        .ant-collapse-header { padding-left: 21px; }
                        .ant-collapse-content {
                            padding-top: 9px;
                            padding-right: 11px;
                            padding-left: 12px;

                            label ~ div {
                                margin-left: 0;
                                flex-wrap: wrap;

                                .flag-select { min-width: 101px; }
                                .rc-slider { margin-top: 29px; margin-bottom: 28px; width: 100%; }
                            }

                            label ~ div:not(:last-child) { margin-bottom: 50px; }
                        }
                    }

                    > :nth-last-child(2) {
                        margin-right: -24px;
                        margin-left: -11px;
                        padding-right: 11px;
                        padding-left: 12px;

                        > *:not(:first-child) {
                            margin-bottom: 31px !important;
                            padding-left: 8px;

                            label + * { margin-left: 0; }
                        }
                        > *:last-child { margin-bottom: 42px; }
                    }

                    > :last-child {
                        margin-right: -24px;
                        margin-left: -11px;
                        padding-right: 11px;
                        padding-left: 12px;

                        .campaign-holder {
                            margin-top: 23px;

                            .adExample__ad-example.adExampleFull__ad-example { margin-top: 0; }
                            .btn-create-campaign { margin: 0; margin-top: 25px; max-width: none; }
                            .submit-terms {
                                margin-left: 17px;
                                
                                input[type='checkbox'] { margin-left: -3px; }
                                > *:last-child { margin-left: -20px; }
                            }
                        }
                    }
                    // -- .blackSection:first-child ~ .blackSection
                }
                // -- .container
            }
        }
        // @media screen and (min-width: 768px) {
        //     .container .o-wrapper { padding-top: 42px; }
        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput { width: 70%; }
            
        //     .container .blackSection:first-child ~ * { padding-right: 25px; padding-left: 32px; }
        // }
        // @media screen and (min-width: 1200px) {
        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select { margin-left: -28px; }
        // }

        // @media screen and (max-width: 767px) {
        //     .regionInput { width: 30%; }
        //     .rc-slider { width: 50%; }
        //     .rc-slider + .inputWrapper { margin-top: 10px; width: 100%; text-align: right; }
        // }                    
        
        // @media screen and (min-width: 992px) {
        //     .campaign-holder { padding: 20px 95px 20px 97px; }
        // }
        // @media screen and (max-width: 991px) {
        //     .campaign-holder {
        //         button { margin-top: 43px !important; }
        //         button, button ~ * { margin-left: 32px !important; }
        //     }
        // }
        // @media screen and (max-width: 767px) {
        //     .campaign-holder {
        //         .adExample__ad-example.adExampleFull__ad-example { margin-top: 5%; }

        //         button, button ~ * { margin-left: 0 !important; }
        //         .submit-terms input[type='checkbox'] { margin-left: -3px; }
        //     }
        // }
    // -- /.Zay modification

    .searchTerm__ad-example { top: 72px !important; }
    .tooltip-label { margin-left: 4px; width: 17px; }

    @media screen and (max-width: 767px) {
        .searchTerm__ad-example { top: 10.2% !important; }
    }

    @media screen and (min-width: 768px) {
        .searchTerm__ad-example { top: 58px !important; }
    }
    
    @media screen and (min-width: 850px) {
        .searchTerm__ad-example { top: 40px !important; }
    }
    
    @media screen and (min-width: 992px) {
        .searchTerm__ad-example { top: 57px !important; }
    }

    @media screen and (min-width: 1199px) {
        .searchTerm__ad-example { top: 72px !important; }
    }



    


`;
export default WithDirection(AddCampaignWrapper);


// WEBPACK FOOTER //
// ./src/containers/AddCampaignForm/style.js